import { Box } from '@mui/material';

// import { FileGroup } from 'ui-component/files';
import PropTypes from 'prop-types';
import { ProjectTables } from 'enums';
import FileGroupNew from 'qubCommon/Files/Input/FileGroup';
import { useState, useEffect } from 'react';

import { FileGroup } from 'common/FileUpload';
import { useFileContext } from 'context/FilesV2';
import { formatFiles } from 'utils';

const PaymentFiles = ({ readOnly, token, recordGuid, fileGroups, fgRefs }) => {
    // const fgRefs = useRef([]);
    const { fileGroups: fileGroupsV2, control: filesControl } = useFileContext();

    useEffect(() => {
        try {
            const formattedFiles = formatFiles(fileGroups);
            if (formattedFiles !== undefined) {
                filesControl.initialize(formattedFiles);
            } else {
                filesControl.initialize([]);
            }
        } catch (error) {
            console.error('error', error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileGroups]);

    return (
        <Box>
            {fileGroupsV2?.map((group, index) => (
                <FileGroup
                    key={group.id}
                    id={group.id}
                    ref={(el) => (fgRefs.current[index] = el)}
                    title={group?.title}
                    maxSize={2097152}
                    maxFiles={5}
                    maxBundles={3}
                    isReadOnly={readOnly}
                    fields={group.fields}
                    bundles={group?.bundles}
                    templates={group?.templates}
                />
            ))}
        </Box>
    );
};

PaymentFiles.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    token: PropTypes.string
};

export default PaymentFiles;
